export const getAllLockers = state => {
    const { allLockers } = state.lockers;
    return allLockers;
};
export const getSiteLockers = state => {
    const { siteLockers } = state.lockers;
    return siteLockers;
};
